import { useCallback } from "react";
import { useNavigate } from "react-router-dom";

import { useRightRail } from "@/context/RightRailContext";
import { isMobileShellViewport } from "@/lib/viewport";

/** Opens Kai in the right rail on desktop; navigates to `/` on mobile. */
export function useOpenKai() {
  const navigate = useNavigate();
  const { toggleKaiPanel } = useRightRail();

  return useCallback(() => {
    if (isMobileShellViewport()) {
      navigate("/");
      return;
    }
    toggleKaiPanel();
  }, [navigate, toggleKaiPanel]);
}
